import { render, staticRenderFns } from "./componentCollapse.vue?vue&type=template&id=4651ba2c&scoped=true"
import script from "./componentCollapse.vue?vue&type=script&lang=js"
export * from "./componentCollapse.vue?vue&type=script&lang=js"
import style0 from "./componentCollapse.vue?vue&type=style&index=0&id=4651ba2c&lang=scss"
import style1 from "./componentCollapse.vue?vue&type=style&index=1&id=4651ba2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651ba2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4651ba2c')) {
      api.createRecord('4651ba2c', component.options)
    } else {
      api.reload('4651ba2c', component.options)
    }
    module.hot.accept("./componentCollapse.vue?vue&type=template&id=4651ba2c&scoped=true", function () {
      api.rerender('4651ba2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentCollapse.vue"
export default component.exports